(() => {
  const switchEls = document.querySelectorAll('.js-switch');
  if (!switchEls || switchEls.length === 0) {
    return;
  }
  const handleChange = () => {
    switchEls.forEach(el => {
      const left = el?.querySelector('.switch__left');
      const right = el?.querySelector('.switch__right');
      const indicator = el?.querySelector('.switch__indicator');
      if (!left || !right || !indicator) {
        return;
      }
      if (left.classList.contains('active')) {
        left.classList.remove('active');
        right.classList.add('active');
        indicator.classList.remove('left');
        indicator.classList.add('right');
        el.dispatchEvent(
          new CustomEvent('change', {
            detail: 'right',
          }),
        );
      } else {
        right.classList.remove('active');
        left.classList.add('active');
        indicator.classList.remove('right');
        indicator.classList.add('left');
        el.dispatchEvent(
          new CustomEvent('change', {
            detail: 'left',
          }),
        );
      }
    });
  };

  switchEls.forEach(el => {
    el.addEventListener('click', () => {
      handleChange();
    });
  });
})();
